<template>
  <div class="component-padding">
      <div class="row">
        <div
          class="col-6 col-md-3"
          v-for="(data,index) in skinCare.slice(
          (this.currentPage - 1) * this.perPage,
          this.currentPage * this.perPage)"
          :key="index"
        >
          <div @click="goTodetail(data.productId)" class="product-item">
            <div class="product-item-lg">
              <img
                :src="require('@/assets/images/' + data.image)"
                :alt="data.image"
                class="product-item-lg-img"
              />
            </div>
            <h3 class="product-item-title">{{data.productTitle}}</h3>
            <p class="product-item-price">{{data.price}}</p>
          </div>
        </div>
      </div>
      <b-pagination
        class="products_pagination"
        v-model="currentPage"
        :total-rows="rows"
        :per-page="perPage"
      ></b-pagination>
      <!-- <p class="mt-3">Current Page: {{ currentPage }}</p> -->
  </div>
</template>

<script>
import productsJson from "@/json/db.json";
export default {
  name: "SkinCare",
  data() {
    return {
      perPage: 12,
      currentPage: 1
    };
  },
  methods: {
    goTodetail(prodId) {
      this.$router.push({ name: "details", params: { Pid: prodId } });
    }
  },
  computed: {
    rows() {
      return this.skinCare.length;
    },
    products() {
      return productsJson.products.map(item => {
        return item;
      });
    },
    skinCare() {
      return this.products
        .filter(i => i.category === "skinCare")
        .sort((a, b) => new Date(b.date) - new Date(a.date));
    }
  }
};
</script>
<style lang="scss">
.product-item-lg {
  width: 100%;
  height: 30vh;
  overflow: hidden;
  &-img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.4s;
  }
  &:hover .product-item-lg-img {
    transform: scale(1.1);
    transform-origin: 50% 50%;
  }
}
@media screen and (min-width: 768px) {
  .product-item-lg{
    height: 50vh;
  }
}
</style>